import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtmltag'
})
export class RemoveHtmltagPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return  value ? String(value).replace(/<[^>]+>/gm, '') : '';
  }

}
